<template>
    <h1 class="text-5xl font-bold select-none text-center lowercase"><slot/></h1>
</template>

<script>
export default {
    name:"PageTitle"
}
</script>